import { get, post } from '@/Api';
import { SelectItem } from '@/Models/Other/SelectItem';
import { SysUserGroup } from '@/Models/Tables/SysUserGroup';
import { ViewSysUserGroup } from '@/Models/Views/ViewSysUserGroup';

const name = 'SysUserGroup';

function getUrl(url: string) {
    return `${name}/${url}`;
}
export function getViews(): Promise<ViewSysUserGroup[]> {
    return get(getUrl("getViews"));
}
export function add(data: SysUserGroup): Promise<ViewSysUserGroup> {
    return post(getUrl("add"), data);
}
export function upd(data: SysUserGroup): Promise<ViewSysUserGroup> {
    return post(getUrl("upd"), data);
}
export function del(id: number): Promise<number> {
    return get(getUrl("del"), { id });
}
export function getSelectItems(): Promise<SelectItem[]> {
    return get(getUrl("getSelectItems"));
}